'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function NEFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-2ay4nvv2d", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-npy8f0u0g", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-eak40tw9w" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-eak40tw9w", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-2ay4nvv2d)" }, /* @__PURE__ */ React.createElement("use", { fill: "#f7fcff", xlinkHref: "#mantine-eak40tw9w" }), /* @__PURE__ */ React.createElement("path", { fill: "#fc6500", d: "M0 0h32v8H0z", mask: "url(#mantine-npy8f0u0g)" }), /* @__PURE__ */ React.createElement("path", { fill: "#5eaa22", d: "M0 16h32v8H0z", mask: "url(#mantine-npy8f0u0g)" }), /* @__PURE__ */ React.createElement("circle", { cx: "16", cy: "12", r: "4", fill: "#fc6500", mask: "url(#mantine-npy8f0u0g)" })))
  );
}

export { NEFlag };
//# sourceMappingURL=NE.mjs.map
